<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.nomenclador')} / ${$t('menu.flights')} / ${$t('menu.pesos')}`"
      >
        <PesoEquipajeList></PesoEquipajeList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import PesoEquipajeList from './tablas/PesoEquipajeList.vue'

export default {
  components: {
    AppCardCode,
    PesoEquipajeList,
  },
}
</script>
